var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-excel-xlsx',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"download_items",attrs:{"data":_vm.DATA_ITEMS,"columns":_vm.HEADER_ITEMS,"file-name":_vm.file_name?_vm.file_name:'kipcount file',"file-type":'xlsx',"sheet-name":_vm.sheet_name?_vm.sheet_name:'items'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }